module.exports = __webpack_public_path__ + "img/img-4.01451f76.png";